var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.items.length)?_c('nav',{attrs:{"role":"tablist"}},_vm._l((_vm.items),function(item){
var _obj;
return _c('nuxt-link',{key:item.alias,class:{ 'nuxt-link-active': _vm.isCurrent(item) },attrs:{"to":_vm.localePath({
      query: Object.assign({}, _vm.$route.query, ( _obj = {}, _obj[_vm.slug] = item.alias, _obj )),
    }),"exact":"","aria-selected":_vm.isCurrent(item),"aria-controls":"pane-profile","role":"tab"},domProps:{"innerHTML":_vm._s(_vm.formatter(item))},nativeOn:{"click":function($event){return _vm.$emit('change', item)}}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }